import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmptyPagePageRoutingModule } from './empty-page-routing.module';

import { EmptyPagePage } from './empty-page.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EmptyPagePageRoutingModule
  ],
  declarations: [EmptyPagePage]
})
export class EmptyPagePageModule {}
